document.addEventListener("DOMContentLoaded", function () {
    const params = new URLSearchParams(window.location.search);
    const pgj = params.get("pgj_fgd");
    if(pgj == "true"){
        document.querySelectorAll("#ps_def_qaa_inp_1")[0].checked = true;
        document.querySelectorAll("#ps_def_qaa_inp_2")[0].checked = true;
    };
});